// ActiveTabContext.js

import React from "react";

const ActiveTabContext = React.createContext({
  moveLineToTab: () => {},
});

export default ActiveTabContext;
